import {
  EXPERIMENTS,
  type ExperimentName,
  type IExperiments
} from '@lifk/types'

export const experimentDefaults = Object.fromEntries(
  Object.entries(EXPERIMENTS).map(([k, v]) => [k, v[0]])
) as IExperiments

function validateEntries(parsed: unknown): Partial<IExperiments> {
  const result: Record<string, string> = {}
  if (!parsed || typeof parsed !== 'object') {
    return result as Partial<IExperiments>
  }

  const entries = parsed as Record<string, unknown>
  for (const name of Object.keys(EXPERIMENTS) as ExperimentName[]) {
    const variant = entries[name]
    if (
      typeof variant === 'string' &&
      (EXPERIMENTS[name] as readonly string[]).includes(variant)
    ) {
      result[name] = variant
    }
  }

  return result as Partial<IExperiments>
}

function readExperimentCookie(): unknown {
  const raw = document.cookie.match(/experiments=([^;]+)/)?.[1]
  if (!raw) return undefined
  try {
    return JSON.parse(decodeURIComponent(raw))
  } catch {
    return undefined
  }
}

export function mergeExperiments(parsed: unknown): IExperiments {
  return { ...experimentDefaults, ...validateEntries(parsed) }
}

export function getExperiments(): IExperiments {
  return mergeExperiments(readExperimentCookie())
}

export function getAssignedExperiments(): Partial<IExperiments> {
  return validateEntries(readExperimentCookie())
}
